import { Link } from 'react-scroll';
import ProductsPage from './Products';
import BenefitsPage from './Benefits';
import ReferencesPage from './References';
import ContactPage from './Contact';
import homeHero from '../assets/img/home-hero.svg';
import BookBtn from '../components/BookBtn';
import './Home.css';
import { Clients } from './Clients';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

function HomePage() {
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {`
                        {
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Squareplan",
                        "url": "https://squareplan.io/",
                        "hasPart": [
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/products/genspace",
                            "name": "Auto Space Plan Generation"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/products/budget-estimate",
                            "name": "Auto Fit Out Valuation"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/products/leasing",
                            "name": "Lease Process Management"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/products/management",
                            "name": "Portfolio Management"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/team",
                            "name": "Team"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/careers",
                            "name": "Careers"
                            },
                            {
                            "@type": "WebPage",
                            "url": "https://squareplan.io/contact",
                            "name": "Contact"
                            },
                            {
                            "@type": "CollectionPage",
                            "url": "https://squareplan.io/blog",
                            "name": "Blog"
                            },
                            {
                            "@type": "BlogPosting",
                            "url": "https://squareplan.io/blog?url=why-design-automation-is-the-future-of-workplace-planning",
                            "headline": "Why Design Automation is the Future of Workplace Planning",
                            "author": {
                                "@type": "Person",
                                "name": "Maciej Markowski",
                                "url": "https://squareplan.io/blog?url=author%2Fmaciej%2F"
                            },
                            "image": "https://blog.squareplan.io/content/images/2025/06/image-new.png"
                            },
                            {
                            "@type": "BlogPosting",
                            "url": "https://squareplan.io/blog?url=rethinking-office-design-when-space-planning-takes-seconds-not-weeks",
                            "headline": "Rethinking Office Design When Space Planning Takes Seconds, Not Weeks",
                            "author": {
                                "@type": "Person",
                                "name": "Maciej Markowski",
                                "url": "https://squareplan.io/blog?url=author%2Fmaciej%2F"
                            },
                            "image": "https://blog.squareplan.io/content/images/2025/06/Futuristic-Cityscape-with-Elevated-Transport.png"
                            }
                        ]
                        }
                    `}
                </script>
            </Helmet>
            <section className="home-section">
                <div className="section-hero-container">
                    <div className="section-hero-left">
                        <div className="home-hero-title">
                            <span>{t('home.title')}</span>
                            <ul>
                                <li className="indented">{t('home.dot1')}</li>
                                <li className="indented">{t('home.dot2')}</li>
                                <li className="indented"> {t('home.dot3')}</li>
                            </ul>
                        </div>
                        <div className="home-hero-subtitle">{t('home.description')}</div>
                        <div className="hero-btn">
                            <Link to="contactPage" smooth={true} duration={500}>
                                <BookBtn stateProp="primary" noClick={true} buttonText={t('home.bookDemo')} />
                            </Link>
                        </div>
                    </div>
                    <div className="section-hero-right">
                        <img src={homeHero} alt="Hero" className="hero-image" />
                    </div>
                </div>
                <Clients />
                <ProductsPage />
                <BenefitsPage
                    className="benefits-1440-1253"
                    frameClassName="benefits-instance"
                    paragraphClassName="benefits-1440-1253-instance"
                    property1="frame-3720"
                />
                <ReferencesPage />
                <div id="contactPage">
                    <ContactPage />
                </div>
            </section>
        </>
    );
}

export default HomePage;
